// extracted by mini-css-extract-plugin
export default {"title":"aba-z","warning":"bba-z","sizeOptionsLegendText":"cba-z"};